export default "__VITE_ASSET__Dvc7pmH7__"